import {Link} from 'react-router-dom';
import HELP from '../stores/Help';
import UI from '../stores/UI';
import BackgroundPicture from '../components/BackgroundPicture'
import Picture from '../components/Picture'
import Markdown from '../components/Markdown'

class ProjectLink extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show: false
    }
  }

  componentDidMount() {
    this.checkPosition()
    window.addEventListener('scroll', this.checkPosition)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.checkPosition, false)
  }

  checkPosition = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (((scrollTop - this.refs.el.offsetTop) + window.innerHeight) > window.innerHeight * 0.2) {
      this.setState({
        show: true
      })
      window.removeEventListener('scroll', this.checkPosition, false)
    }
  }

  handleClick = e => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    console.log(scrollTop - e.clientY)
    // console.log((scrollTop - this.refs.el.offsetTop) + window.innerHeight))
  }

  render() {

    const shiftRight = this.props.thumbnailShift ? this.props.thumbnailShift[0] === 'right' : false;
    const shiftLeft = this.props.thumbnailShift ? this.props.thumbnailShift[0] === 'left' : false;
    const image = HELP.getMedia(this.props.thumbnail);

    return (
      <Link to={{
        pathname: `/project/${this.props.slug}`,
        state: { modal: true }
      }}>
        <div className={`project-link no-margins ${shiftRight ? 'shift-r' : ''}${shiftLeft ? 'shift-l' : ''}`} ref="el" style={{
          opacity: this.state.show ? 1 : 0,
          transform: this.state.show ? `translateY(0%)` : `translateY(2rem)`,
          transition: `0.75s`
        }}>
          <figure className="thumbnail" style={{
            paddingTop: `${image.height / image.width * 100}%`
          }}>
            <Picture className="thumb-image cover" {...image} />
            {!UI.isTouch ? (
              <div className="thumb-info overlay">
                <Markdown className="text center fs" convert={this.props.thumbnailCaption} />
              </div>
            ) : null}
          </figure>
          {UI.isTouch ? (
            <div className="thumb-info inner">
              <Markdown className="text center fs" convert={this.props.thumbnailCaption} />
            </div>
          ) : null}
        </div>
      </Link>
    )
  }
}

export default ProjectLink



// WEBPACK FOOTER //
// ./app/javascript/packs/components/ProjectLink.js